import { render, staticRenderFns } from "./PsiFormVerifySwitch.vue?vue&type=template&id=ea776dc8&scoped=true&"
import script from "./PsiFormVerifySwitch.vue?vue&type=script&lang=js&"
export * from "./PsiFormVerifySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea776dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VIcon,VSwitch})
